import ImageCollectionPage from "../components/ImageCollectionPage";

export default function Food() {
  return <ImageCollectionPage title="Food" path="/culture/food" collection="culture_food" />;
}
